import Vue from "vue";
import App from "./App";
import "./app.css";

Vue.config.productionTip = false;

Vue.filter("toDate", date => {
    const months = [
        "Jan",
        "Feb",
        "Mar",
        "Apr",
        "May",
        "Jun",
        "Jul",
        "Aug",
        "Sep",
        "Oct",
        "Nov",
        "Dec"
    ];
    const month = months[date.getMonth()];

    return `${date.getDate()}-${month}`; // -${date.getFullYear()}`;
});

Vue.filter("toFullDate", date => {
    if (date === "") {
        return "";
    }
    const months = [
        "Jan",
        "Feb",
        "Mar",
        "Apr",
        "May",
        "Jun",
        "Jul",
        "Aug",
        "Sep",
        "Oct",
        "Nov",
        "Dec"
    ];
    const month = months[date.getMonth()];

    return `${date.getDate()}-${month}-${date.getFullYear()}`;
});

/* eslint-disable no-new */
new Vue({
    el: "#app",
    render: h => h(App)
});



// WEBPACK FOOTER //
// ./src/main.js